<template>
  <div class="home-float" v-if="isShowModal&&isShowIndexAD && wnsPCHomeFloatList.length>0">
    <div class="img-wrap">
      <div
        class="img-item"
        v-for="(item,index) in wnsPCHomeFloatList"
        :key="item.sort"
        v-show="index==0"
      >
        <img :src="item.imgLink" @click="goHref(item.imgClickLink)" />
        <div class="closeicon" @click="imgHandleClick(index)"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { commonApi, common } from '@/common/index';

export default {
  name: 'homeFloat',
  data() {
    return {
      isShowModal:true,
      wnsPCHomeFloatList: []
    }
  },
  computed: {
    ...mapState({
      isShowIndexAD: state => state.isShowIndexAD,
      indexADCloseNum: state => state.indexADCloseNum,
      isLogin:  state => state.isLogin,
    })
  },
  watch:{
    indexADCloseNum:{
      handler(num){
        // console.log(num)
      },
      immediate:true
    },
    isLogin:{
      handler(val){
        this.fetchImg()
      },
      immediate:true
    }
  },
  methods: {
    ...mapMutations([
      'CLOSE_INDEX_AD','setADCloseNum','set_CLOSE_INDEX_AD'
    ]),
    fetchImg() {
      
      commonApi.HOMEBEFORE.fetchImg('yhPCHomeImageNav')
        .then((data) => {
          this.wnsPCHomeFloatList = data.reverse();
          this.wnsPCHomeFloatList = this.wnsPCHomeFloatList.slice(this.indexADCloseNum);
                //获取上次弹框时间
          var oldTime = Number(common.getCookie("9570FloatModalTime"));
          var nowTime = Number(new Date().getTime());
          if (!oldTime) {
            this.isShowModal = true;
             common.setCookie("9570FloatModalTime", nowTime);
          } else if (nowTime - oldTime > 28800000 && this.wnsPCHomeFloatList.length>0) {
            common.setCookie("9570FloatModalTime", nowTime);
            this.isShowModal = true;
          }else{
              this.isShowModal = false;
          }
        })

    },
    goHref(url) {
      let path = common.goHref(url);
      if (path) {
        this.$router.push({ path: path })
      }
    },
    imgHandleClick(index) {
      this.setADCloseNum(1)
      this.wnsPCHomeFloatList.splice(index, 1)
      if( this.wnsPCHomeFloatList.length ==0 ){
        this.set_CLOSE_INDEX_AD();
      }
    }
  },
  created() {
    // this.fetchImg()
  }

}
</script>

<style scoped lang="scss">
@import '../../style/animate.css';
.home-float {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 999;
  text-align: center;
  .img-wrap {
    position: fixed;
    z-index: 2201;
    width: 600px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .closeicon {
      width: 54px;
      height: 54px;
      background: url(./img/close.png) no-repeat;
      background-size: 100% 100%;
      position: absolute;
      right: 0;
      top: 0;
      margin-right: -27px;
      margin-top: -27px;
      cursor: pointer;
    }
    img {
      width: 100%;
      cursor: pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/build08/components/pendant/homeFloat.vue